export enum AppType {
  WebApp = 1,
  CommissioningWebApp = 2,
  LocalApp = 3,
  CommissioningMobileApp = 4,
}
